var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocksmithDoorlock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 15C15.7426 15 16.75 13.9926 16.75 12.75C16.75 11.5074 15.7426 10.5 14.5 10.5C13.2574 10.5 12.25 11.5074 12.25 12.75C12.25 13.9926 13.2574 15 14.5 15Z",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 13.5C14.8011 13.5 14.6103 13.421 14.4697 13.2803C14.329 13.1397 14.25 12.9489 14.25 12.75C14.25 12.5511 14.329 12.3603 14.4697 12.2197C14.6103 12.079 14.8011 12 15 12",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 12H8L7.25 12.75L8 13.5L8.75 13L9.5 13.5L10.25 13L11 13.5H11.25",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 8V11",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1875 14.5C9.89422 15.1678 9.41318 15.736 8.80289 16.1355C8.19261 16.535 7.47939 16.7484 6.75 16.75C5.75635 16.747 4.80425 16.351 4.10163 15.6484C3.39901 14.9458 3.00297 13.9936 3 13V5C3.00297 4.00635 3.39901 3.05425 4.10163 2.35163C4.80425 1.64901 5.75635 1.25297 6.75 1.25V1.25C7.5695 1.25261 8.36576 1.52258 9.01787 2.01891C9.66997 2.51524 10.1423 3.21081 10.3631 4",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3 7.25H1.25V4.75H1.75",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3 12.75H1.5V9.75H3",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99999 10.7498C8.00095 10.5365 7.9473 10.3264 7.84416 10.1397C7.74102 9.95302 7.59182 9.7958 7.41075 9.68305C7.22968 9.5703 7.02276 9.50575 6.8097 9.49557C6.59663 9.48538 6.38451 9.52989 6.1935 9.62485C6.0025 9.71982 5.83898 9.86208 5.71849 10.0381C5.59801 10.2141 5.52458 10.418 5.50518 10.6305C5.48578 10.8429 5.52107 11.0568 5.60768 11.2517C5.69429 11.4466 5.82934 11.6161 5.99999 11.7441V13.4998C5.99999 13.6987 6.07901 13.8894 6.21966 14.0301C6.36031 14.1707 6.55108 14.2498 6.74999 14.2498",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 7H6.75C6.48478 7 6.23043 6.89464 6.04289 6.70711C5.85536 6.51957 5.75 6.26522 5.75 6C5.75 5.73478 5.85536 5.48043 6.04289 5.29289C6.23043 5.10536 6.48478 5 6.75 5H14.5C14.7652 5 15.0196 5.10536 15.2071 5.29289C15.3946 5.48043 15.5 5.73478 15.5 6C15.5 6.26522 15.3946 6.51957 15.2071 6.70711C15.0196 6.89464 14.7652 7 14.5 7Z",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocksmithDoorlock);
export default __webpack_public_path__ + "static/media/locksmith-door lock.35c10611.svg";
export { ForwardRef as ReactComponent };